/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_ExpiredInputs */



/**
* | output |
* | --- |
* | "This sign-in did not finish. Start again or use the email link." |
*
* @param {Portal_X13_Error_ExpiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_expired = /** @type {((inputs?: Portal_X13_Error_ExpiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_ExpiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This sign-in did not finish. Start again or use the email link.")
});